<script setup lang="ts">
import { useForwardProps } from "reka-ui";
import Popover, { type PopoverProps } from "../popover/Popover.vue";

interface Props extends Omit<PopoverProps, "open"> {
	closeOnClick?: boolean;
}

const props = defineProps<Props>();

const forwardedProps = useForwardProps(props);

const open = defineModel<boolean>("open");

defineSlots<{
	default(): void;
	activator(): void;
	trigger(): void;
}>();

function handleClick() {
	if (props.closeOnClick && open.value) {
		open.value = false;
	}
}
</script>

<template>
	<Popover v-model:open="open" v-bind="forwardedProps">
		<template #trigger>
			<slot name="trigger">
				<slot name="activator" />
			</slot>
		</template>

		<div @click.stop.prevent="handleClick">
			<slot />
		</div>
	</Popover>
</template>
